import { render, staticRenderFns } from "./DASecondaryButton.vue?vue&type=template&id=4462ee0b"
import script from "./DASecondaryButton.vue?vue&type=script&lang=js"
export * from "./DASecondaryButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports